
export interface ExternalHealthEntityPlanDTO {
    externalId: string;
    entityName: string;
}

export const defaultExternalHealthEntityPlanDTO: ExternalHealthEntityPlanDTO = {
    externalId: '',
    entityName: ''
}
